import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import Link from "gatsby-link"
import InlineSVG from "react-inlinesvg"

import Container from "../../container"
import Carousel from "./slider"

import MoreWorkIcon from "../../../assets/images/more-work-icon.svg"

const Heading = styled.h2`
  text-align: center;
  color: #ff2300;
  font-size: ${rem(16)};
  font-weight: 400;
  margin-bottom: ${rem(100)};

  @media ${props => props.theme.mobileDown} {
    font-size: ${rem(14)};
    margin-bottom: ${rem(30)};
    margin-top: ${rem(60)};
  }
`

const MoreWorkLink = styled(Link)`
  width: ${rem(88)};
  display: block;
  margin: 0 auto;
  margin-top: ${rem(100)};

  @media ${props => props.theme.desktopDown} {
    width: ${rem(50)};
  }

  img {
    display: block;
    max-width: 100%;
  }

  @media ${props => props.theme.mobileDown} {
    width: ${rem(30)};
  }
`

const ProjectsSlider = props => {
  return (
    <Container>
      <Heading>FEATURED WORK</Heading>

      <Carousel projects={props.projects} />

      <MoreWorkLink to="/work" aria-label="More Work">
        <InlineSVG src={MoreWorkIcon} />
      </MoreWorkLink>
    </Container>
  )
}

export default ProjectsSlider
